<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-10-26 15:15:35
 * @LastEditTime: 2022-03-24 16:40:19
-->
<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-button
        v-if="Permission.indexOf(242) !== -1"
        type="primary"
        size="mini"
        @click="addTemplate"
        >{{ $t("lang.terminalList.add") }}</el-button
      >
    </div>
    <TableComponent
      :Columns="Columns"
      :data="templateList"
      :ColuumnsButton="ColuumnsButton"
      :ColuumnsButtonWidth="240"
      @editCollection="editCollection"
      @deleteCollection="deleteCollection"
      @sortChange="sortChange"
      :seek="seek"
    >
      <span
        slot="slot"
        slot-scope="scope"
        style="color:#409eff;font-size:15px;"
        >{{ scope.scope.$index }}</span
      >
      <span slot="customColumn" slot-scope="scope" style="font-size:15px;">{{
        scope.scope.row.ts | formateDate
      }}</span>
      <span slot="typeslot" slot-scope="scope" style="font-size:15px;">{{
        typeListObj[scope.scope.row.type.toString()]
      }}</span>
    </TableComponent>
    <pagination
      :total="total"
      :offset="offset"
      :limit="limit"
      @SizeChanges="SizeChanges"
      @CurrentChanges="CurrentChanges"
    ></pagination>
    <!-- 添加采集配置 -->
    <cont-dialog ref="contDialog" @updateList="queryKeyword"></cont-dialog>
  </div>
</template>
<script>
import { typeListOptions, typeListObj } from "@/utils/paramsConfig";
import TableComponent from "@/components/TableComponent/index";
import pagination from "@/components/pagination";
import { Columns, ColuumnsButton } from "./tableConfig";
import { PublicComponent } from "@/mixins/common";
import contDialog from "./components/contDialog";
import {
  getTemplate,
  deleteTemplate,
  queryTempalte,
} from "@/api/cloudMonitor/templateList";
import moment from "moment";
import { getPermission } from "@/cookie/cookie";
export default {
  components: {
    TableComponent,
    pagination,
    contDialog,
  },
  mixins: [PublicComponent],
  data() {
    return {
      typeListOptions,
      typeListObj,
      Columns,
      ColuumnsButton,
      templateList: [],
      seek: {
        tempName: "",
        sortNum: "",
      },
      Permission: [],
    };
  },
  mounted() {
    this.queryKeyword();
    this.Permission = getPermission();
  },
  filters: {
    formateDate(time) {
      if (time) {
        return moment(time).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "";
      }
    },
  },
  methods: {
    // 获取数据
    queryKeyword() {
      let params = {
        current: this.offset,
        size: this.limit,
        tempName: this.seek.tempName ? this.seek.tempName : undefined,
        sortNum: this.seek.sortNum ? this.seek.sortNum : 4,
        type: this.seek.tempType ? this.seek.tempType : undefined,
      };
      queryTempalte(params).then((res) => {
        if (res.data.code === 0) {
          let data = res.data.data;
          this.templateList = data.records;
          this.total = data.total;
        }
        this.templateList.unshift({});
      });
    },
    // 排序
    sortChange(column, prop) {
      if (prop == "name") {
        if (column.order == "descending") {
          this.seek.sortNum = 2;
        } else {
          this.seek.sortNum = 1;
        }
      } else if (prop == "ts") {
        if (column.order == "descending") {
          this.seek.sortNum = 4;
        } else {
          this.seek.sortNum = 3;
        }
      } else {
        this.seek.sortNum = "";
      }
    },
    editCollection(row) {
      this.$refs.contDialog.show(row);
    },
    // 添加采集配置
    addTemplate() {
      this.$refs.contDialog.show();
    },
    deleteCollection(row) {
      deleteTemplate(row.id)
        .then((res) => {
          if (res.data.code === 0) {
            this.$message.success(this.$t("lang.collect.msg4"));
            this.offset = 1;
            this.queryKeyword();
          } else if (res.data.code === 52) {
            this.$message({
              message: this.$t("lang.collect.msg11"),
              type: "warning",
            });
          } else {
            this.$message.error(this.$t("lang.collect.msg8"));
          }
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped></style>
